import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const SmartphoneIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <rect x="5" y="2" width="14" height="20" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.80001 23.406C4.77829 23.406 3.95001 22.5778 3.95001 21.556L3.95001 2.40604C3.95001 1.38431 4.77829 0.556038 5.80001 0.556038H18.2C19.2217 0.556038 20.05 1.38431 20.05 2.40604V21.556C20.05 22.5778 19.2217 23.406 18.2 23.406H5.80001ZM5.65001 21.556C5.65001 21.6389 5.71717 21.706 5.80001 21.706H18.2C18.2829 21.706 18.35 21.6389 18.35 21.556V2.40604C18.35 2.32319 18.2829 2.25604 18.2 2.25604H5.80001C5.71717 2.25604 5.65001 2.32319 5.65001 2.40604L5.65001 21.556Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50012 18.3H14.5001V20H9.50012V18.3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default SmartphoneIconFilled;
